import { useEffect } from 'react';

interface SEOSchemaProps {
  schema: object | object[];
  id?: string;
}

const SEOSchema = ({ schema, id = 'seo-schema' }: SEOSchemaProps) => {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.text = JSON.stringify(Array.isArray(schema) ? schema : schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [id, schema]);

  return null;
};

export default SEOSchema;
